//Yotpo subscription helper script to prepend 'best offer' callout

//Define wrapper to be observed for changes with MutationObserver
  const observedWrapper = document.querySelector('.supplement-form__button-wrapper')

  //Observer for changes to Yotpo wrapper widget & append featured offer banner
  let MutationObserve = new MutationObserver(function(mutations) {
    const yotpoSubsWrapper = document.querySelector('.yotpo-plans-and-policy-wrapper');
    if (yotpoSubsWrapper) {
      this.disconnect()
      if (window.localStorage.getItem("activeCurrency") == 'AUD' ) {
        appendOffer()
      }
    }
  })

  MutationObserve.observe(observedWrapper, {
    attributes: true,
    childList: true,
    subtree: true,
  });

  //Prepends the offer callout to the yotpo subscription deal once widget is loaded
  function appendOffer() {
    //Declare nessacary variables
    planCallout = document.querySelector('.yotpo-plan-deal');
    yotpoWrapper = document.querySelector('.yotpo-widget-subscriptions-add-to-cart.yotpo-widget-override-css.yotpo-widget-clear')
    bestValueSubscription = document.querySelector('.yotpo-selling-plans > div:nth-child(2)')
    yotpoBuyOnceButton = document.querySelector('.yotpo-radio-buy-once-container .yotpo-radio-buttons')
    yotpoBuySubscriptionButton = document.querySelector('.yotpo-radio-subscription-container .yotpo-radio-buttons input')
    productForm = document.querySelector('.supplement-form__buy-button form')
    //Prepend offer callout
    planCallout.style.display = "flex";
    yotpoWrapper.style.display = "block";
    yotpoWrapper.style.width = "100%";
    bestValueSubscription.prepend(planCallout);
    attrCreated = false
    if (document.querySelectorAll('[name="properties[_Special]').length == 1) {
      attrCreated = true
    }
    yotpoBuySubscriptionButton.addEventListener("click", (e) => {
    
      if (!attrCreated){
        attrCreated = true

        //Create product attributes
        subscriptionAttr = document.createElement("Input")
        subscriptionAttr.setAttribute("type", "hidden")
        subscriptionAttr.setAttribute("name", "properties[_Special]")
        subscriptionAttr.setAttribute("value", "Subscription")


        //Get selling first selected selling plan name
        subscriptionDetails = e.target.getAttribute("data-selling-plan-name")
        subscriptionAttr.setAttribute("value", "Subscription " + subscriptionDetails)

        //Listen for changes to plan selection & update product attribute
        document.querySelectorAll('.yotpo-frequency-options input').forEach(element => {
          element.addEventListener("click", function(e) {
          subscriptionDetails = e.target.getAttribute("data-label")
          subscriptionAttr.setAttribute("value", "Subscription " + subscriptionDetails)
          })
        });
      } else {
        productForm.appendChild(subscriptionAttr);
        return;
      }

      //Append the element to inside the product form
      productForm.appendChild(subscriptionAttr)

    })

    //Remove the attribute from DOM if "buy-once" is clicked
    yotpoBuyOnceButton.addEventListener("click", function() {
      subscriptionAttr.remove()
    })

  }


  // Show subscription depending on currency change if AUD
  window.addEventListener("currency_changed", (e) => {
    if (e.detail.currency == "AUD") {
      appendOffer()
    } else {
      yotpoWrapper.style.display = "none";
    }
  });